import { track } from '@amplitude/analytics-browser';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { OnboardingFlowService } from '../../services/onboarding-flow.service';

@Component({
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  selector: 'app-onboarding-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss']
})
export class StartComponent implements OnInit {
  constructor(private flowService: OnboardingFlowService) {}

  ngOnInit(): void {
    track('web_magazines_proof_view');
  }

  continueButtonClicked(): void {
    this.flowService.handleFinishedStartScreen();
  }
}
